var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCog } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BDropdown, BDropdownItem, BDropdownText, BModal } from "bootstrap-vue";
import { toRef } from "vue";
import { deleteAllHiddenContent, purgeAllDeletedContent, unhideAllHiddenContent, } from "@/components/History/model/crud";
import { iframeRedirect } from "@/components/plugins/legacyNavigation";
import { useHistoryContentStats } from "@/composables/historyContentStats";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DefaultOperations',
    props: {
        history: null
    },
    emits: ["update:operation-running"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faCog);
        const { numItemsDeleted, numItemsHidden } = useHistoryContentStats(toRef(props, "history"));
        function onCopy() {
            iframeRedirect("/dataset/copy_datasets");
        }
        function unhideAll() {
            runOperation(() => unhideAllHiddenContent(props.history));
        }
        function deleteAllHidden() {
            runOperation(() => deleteAllHiddenContent(props.history));
        }
        function purgeAllDeleted() {
            runOperation(() => purgeAllDeletedContent(props.history));
        }
        function runOperation(operation) {
            return __awaiter(this, void 0, void 0, function* () {
                emit("update:operation-running", props.history.update_time);
                yield operation();
                emit("update:operation-running", props.history.update_time);
            });
        }
        return { __sfc: true, props, emit, numItemsDeleted, numItemsHidden, onCopy, unhideAll, deleteAllHidden, purgeAllDeleted, runOperation, faCog, FontAwesomeIcon, BDropdown, BDropdownItem, BDropdownText, BModal, deleteAllHiddenContent, purgeAllDeletedContent };
    }
});
